import {Decimal} from 'decimal.js';

export function parseDecimal(value, nDecimals, defaultValue = 0) {
  try {
    if (
      value === Infinity ||
      value === -Infinity ||
      Number.isNaN(value) ||
      (value instanceof Decimal && (value.isNaN() || !value.isFinite()))
    ) {
      return new Decimal(NaN);
    } else if (!value) {
      return new Decimal(0);
    }
    return new Decimal(value).toDecimalPlaces(nDecimals);
  } catch (e) {
    console.error('Error while converting to decimal', e);
    return new Decimal(defaultValue).toDecimalPlaces(nDecimals);
  }
}
